<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Edit grid": "Raster bearbeiten",

        "Entry": "Einstiegspunkt",
        "Menu root": "Gesamtes Menü",
        "Menu": "Menü",
        "Menu item": "Menüelement",
        "Active menu item": "Aktives Menüelement",
        "Custom menu item": "Benutzerdefiniertes Menüelement",
        "Max depth": "Maximale Tiefe",

        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Grid": "Raster",
        "from": "ab",
        "to": "bis",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "e.g. 40px, 10%, 2em, ...": "z.B. 40px, 10%, 2em, ..."
    }
}
</i18n>

<script>

import _ from 'lodash'

import {
    set,
    isTokenValidOrUndefined,
    fetchAccessToken,
    addContentToSection,
    sortContents,
} from '@/helpers'

import Section from '@/components/Page/Sections/Section'

export default {
    name: 'Menu',
    extends: Section,
    data() {
        return {
            tabs: false,
        }
    },
    watch: {
        customMenuItem(value) {
            if (value) this.addMenuRelatedContent()
            else this.removeMenuRelatedContent()
        }
    },
    computed: {
        settings() {
            let settings = _.get(this.sectionConfig, 'settings')
                || _.get(this.defaultConfig, 'settings') || []

            settings = _.cloneDeep(settings)

            const entry = _.findIndex(settings, el => el.key === 'entry')
            let replace = 1
            if (entry === -1) replace = 0
            settings.splice(entry + 1, replace, {
                key: 'entry',
                name: this.$t('Entry'),
                type: 'select',
                options: [
                    {
                        key: 'root',
                        value: this.$t('Menu root'),
                        default: false
                    },
                    {
                        key: 'active-menu-item',
                        value: this.$t('Active menu item'),
                        default: true
                    },
                    {
                        key: 'custom-menu-item',
                        value: this.$t('Custom menu item'),
                        default: false
                    },
                ]
            })

            let menus = _.get(this.activeCms, 'config.template.menus') || [];
            menus = _.orderBy(menus, 'position');

            // let active = true
            let options = menus.map(menu => {
                let option

                const showMenu = this.checkGlobalConditions(menu)
                if (showMenu) {
                    option = {
                        key: menu.key,
                        value: menu.name,
                        // default: active
                        default: false
                    }
                    // active = false
                }

                return option
            }).filter(Boolean)

            const settingValues = _.get(this.drawer.section, 'settings') || _.get(this.section, 'settings') || []
            if (options.length && ! settingValues.find(el => el.key === 'menu' && el.value)) {
                this.updateSetting({ key: 'menu', value: options[0].key })
            }

            let menu = _.findIndex(settings, el => el.key === 'menu')
            replace = 1
            if (menu === -1) {
                menu = entry + 1
                replace = 0
            }
            settings.splice(menu + 1, replace, {
                key: 'menu',
                name: this.$t('Menu'),
                type: 'select',
                options,
                conditions: [
                    {
                        type: 'eval',
                        condition: "['root'].includes(settings.entry)"
                    }
                ]
            })

            let depth = _.findIndex(settings, el => el.key === 'max-depth')
            replace = 1
            if (depth === -1) {
                depth = menu + 1
                replace = 0
            }
            settings.splice(depth + 1, replace, {
                key: 'max-depth',
                name: this.$t('Max depth'),
                type: 'numberfield',
                min: 1,
                precision: 1,
                step: 1,
                value: 1
            })

            return settings
        },
        requiredContents() {
            return {
                menuItem: {
                    key: 'menu-item',
                    initialize: true,
                    min: 1,
                    max: 1,
                    fields: [
                        {
                            key: 'hyperlink',
                            name: this.$t('Menu item'),
                            type: 'linkfield',
                        },
                    ],
                    settings: [
                        {
                            field: 'hyperlink',
                            key: 'link_types',
                            name: this.$t('Link'),
                            type: 'init',
                            options: [
                                {
                                    key: 'internal',
                                    default: true
                                },
                            ]
                        },
                    ],
                },
            }
        },

        contents() {
            let contents = []

            const section = _.get(this.drawer, 'section') || this.section
            section.contents.forEach(content => {
                switch (content.key) {
                    case 'menu-item':
                        contents.push(this.requiredContents.menuItem)
                        break;
                }
            })

            const configs = _.get(this.defaultConfig, 'contents') || []
            configs.forEach(config => {
                const sorted = _.orderBy(contents, 'position', 'desc')

                let position = 1
                if (sorted.length) position = sorted[0].position + 1

                let content = _.cloneDeep(config)
                content.position = position

                contents.push(content)
            })

            return contents.sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
        customMenuItem() {
            return _.get(this.settingValues, 'entry') === 'custom-menu-item'
        },
    },
    methods: {
        addMenuRelatedContent() {
            const section = _.get(this.drawer, 'section') || this.section
            _.each(this.requiredContents, config => {
                const c = section.contents.findIndex(el => el.key === config.key)
                if (c < 0) {
                    const content = { position: config.position }
                    addContentToSection(section, config, content)
                } else {
                    // TODO
                    // const payload = {
                    //     i: this.i,
                    //     s: this.s,
                    //     c
                    // }
                    // store.commit(`${this.module}/form/unmarkContentAsDeleted`, payload)
                }
            })

            // this.scopedUI.settings = this.edit
        },
        removeMenuRelatedContent() {
            const section = _.get(this.drawer, 'section') || this.section
            _.each(this.requiredContents, config => {
                const c = _.findIndex(section.contents, el => el.key === config.key)
                if (c >= 0) {
                    // const payload = {
                    //     i: this.i,
                    //     s: this.s,
                    //     c
                    // }
                    // store.commit(`${this.module}/form/markContentAsDeleted`, payload)
                    section.contents.splice(c, 1)
                }
            })
        },
        checkGlobalConditions(setting) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.globalSettingValues
            try {
                const conditions = setting.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
    },
    mounted() {
        if (this.customMenuItem) this.addMenuRelatedContent()
        else this.removeMenuRelatedContent()
    }
}
</script>
